export class Operateur {

  public static mtn = 'mtn_money';
  public static moov = 'moov_money';
  public static orange = 'orange_money';
  public static wave = 'wave_money';
  public static paypal = 'paypal';
  public static visa = 'visa';
  public static mastercard = 'mastercard';



}
